import { useState, useEffect } from "react";
import styles from "./Polymatch.module.css";
import GuestNav from "../Navbars/GuestNav";
import Footer from "../Footer";
import CertificateVerification from "../CertificateVerification";
import Testimonials from "../Testimonials";
import FAQ from "../FooterPages/newfaq";
import { Link } from "react-router-dom";
import polymatchLogo from "../../assets/polymatchlogo.png";
import poly1 from "../../assets/polymatch1.png";
import poly2 from "../../assets/polymatch2.png";
import polyeng from "../../assets/polyeng.png";
import polymath from "../../assets/polymath.png";
import polysci from "../../assets/polysci.png";
import polycode from "../../assets/polycode.png";
import polygraphic from "../../assets/polygraphic.png";
import polyiq from "../../assets/polyiq.png";
import polyislamic from "../../assets/polyislamic.png";
import polyart from "../../assets/polyart.png";
import arrowLeft from "../../assets/arrowleft.png";
import arrowRight from "../../assets/arrowright.png";
import flagPakistan from "../../assets/pakistan.png";
import flagJapan from "../../assets/japan.png";
import flagSaudiArabia from "../../assets/saudi_arabia.png";
import flagNorway from "../../assets/norway.png";
import flagUAE from "../../assets/united_arab_emirates.png";
import flagUSA from "../../assets/united_states_of_america.png";
import polystudent from "../../assets/polystudent.png";
import polyglobal from "../../assets/polyglobal.png";
import polylearning from "../../assets/polylearning.png";
import polytop from "../../assets/polytop.png";
import polygame from "../../assets/polygame.png";
import polymaterial from "../../assets/polymaterial.png";
import polylive from "../../assets/polylive.png";
import polytrophy from "../../assets/polytrophy.png";
import polyans from "../../assets/polyans.png";
import hand from "../../assets/hand.png";
import polyex from "../../assets/polyex.png";
import polystu from "../../assets/polystu.png";
import polyearly from "../../assets/polyearly.png";
import ss1 from "../../assets/ss1.png";
import ss2 from "../../assets/ss2.png";
import ss3 from "../../assets/ss3.png";
import ss4 from "../../assets/ss4.png";
import ss5 from "../../assets/ss5.png";
import ss6 from "../../assets/ss6.png";
import ss7 from "../../assets/ss7.png";
import ss8 from "../../assets/ss8.png";
import ss9 from "../../assets/ss9.png";

const Polymatch = () => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    // Ensures Comic Sans is loaded (handled by @import in CSS)
  }, []);

  return (
    <>
      <GuestNav />
      <section className={styles.headerSection}>
        <div className={styles.headerContainer}>
          <img
            src={polymatchLogo}
            alt="Polymatch Logo"
            className={styles.polymatchLogo}
          />
          <h1 className={styles.headerHeading}>
            PolyMatch is a global competition platform by Polymath-Kids, dedicated
            to providing STEM education and 21st-century life skills in a fun,
            engaging environment. Through competitions like Mental Math, Coding,
            Islamic Knowledge, Declamation, and Graphic Designing, PolyMatch
            nurtures young minds and inspires intellectual exploration across the
            globe.
          </h1>
          <div className={styles.headerButtons}>
            <Link to="/PolymatchReg" className={styles.registerBtn}>Register Now</Link>
            <Link to="/PolymatchDetail" className={styles.detailsBtn}>Details for Competition</Link>
          </div>
          <img src={poly1} alt="Poly 1" className={styles.poly1Img} />
          <img src={poly2} alt="Poly 2" className={styles.poly2Img} />
        </div>
      </section>

      <section className={styles.competitionsSection}>
        <h2 className={styles.competitionsHeading}>
          <span className={styles.competitionsPart1}>PolyMatch Competitions – Global </span><br />
          <span className={styles.competitionsPart2}>Challenges for Young Minds</span>
        </h2>
        <div className={styles.competitionsGrid}>
          <div className={styles.competitionItem}>
            <img src={polyeng} alt="English Linguistic Competition" className={styles.competitionImage} />
          </div>
          <div className={styles.competitionItem}>
            <img src={polymath} alt="Mental Math Competition" className={styles.competitionImage} />
          </div>
          <div className={styles.competitionItem}>
            <img src={polysci} alt="Science Competition" className={styles.competitionImage} />
          </div>
          <div className={styles.competitionItem}>
            <img src={polycode} alt="Coding Competition" className={styles.competitionImage} />
          </div>
          <div className={styles.competitionItem}>
            <img src={polygraphic} alt="Graphic Designing Competition" className={styles.competitionImage} />
          </div>
          <div className={styles.competitionItem}>
            <img src={polyiq} alt="IQ Competition" className={styles.competitionImage} />
          </div>
          <div className={styles.competitionItem}>
            <img src={polyislamic} alt="Islamic Knowledge Competition" className={styles.competitionImage} />
          </div>
          <div className={styles.competitionItem}>
            <img src={polyart} alt="Arts and Poster Competition" className={styles.competitionImage} />
          </div>
        </div>
      </section>

      <section className={styles.upcomingCompetitionSection}>
        <h2 className={styles.upcomingCompetitionHeading}>
          <span className={styles.upcomingCompetitionPart1}>Our Upcoming Competition Is On </span><br />
          <span className={styles.upcomingCompetitionPart2}>20 & 21 June 2025</span>
        </h2>
        <h3 className={styles.globalScienceHeading}>Global Science Knowledge Competition</h3>
        <p className={styles.globalScienceParagraph}>
          The PolyMatch Global Science Knowledge Competition ignites curiosity and celebrates the wonders of science from around the world. This exciting event brings together brilliant minds to explore concepts in physics, chemistry, biology, and beyond. Encouraging innovation, critical thinking, and discovery, participants deepen their scientific understanding while building meaningful global connections in a dynamic and inspiring atmosphere
        </p>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <Link to="/PolymatchReg" className={styles.registerBtn}>Register Now</Link>
        <div className={styles.emptySpace}></div>
        <Link to="/IndividualCompetition" className={styles.registerBtn}>Individual Competition</Link>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <div className={styles.flagsWrapper}>
          <img src={flagPakistan} alt="Pakistan Flag" className={styles.flagImage} />
          <img src={flagJapan} alt="Japan Flag" className={styles.flagImage} />
          <img src={flagSaudiArabia} alt="Saudi Arabia Flag" className={styles.flagImage} />
          <img src={flagNorway} alt="Norway Flag" className={styles.flagImage} />
          <img src={flagUAE} alt="United Arab Emirates Flag" className={styles.flagImage} />
          <img src={flagUSA} alt="United States of America Flag" className={styles.flagImage} />
        </div>

      </section>

      <section className={styles.advantagesSection}>
        <h2 className={styles.advantagesHeading}>
          <span className={styles.advantagesPart1}>Advantages of Participating in </span><br />
          <span className={styles.advantagesPart2}>PolyMatch Competitions</span>
        </h2>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <div className={styles.advantagesGrid}>
          <div className={styles.advantageItem}>
            <img src={polygame} alt="Gamified" className={styles.advantageImage} />
          </div>
          <div className={styles.advantageItem}>
            <img src={polyglobal} alt="Global Access" className={styles.advantageImage} />
          </div>
          <div className={styles.advantageItem}>
            <img src={polylive} alt="Live Quiz Competitions" className={styles.advantageImage} />
          </div>
          <div className={styles.advantageItem}>
            <img src={polymaterial} alt="Material Ready" className={styles.advantageImage} />
          </div>
          <div className={styles.advantageItem}>
            <img src={polyans} alt="Answer Display" className={styles.advantageImage} />
          </div>
          <div className={styles.advantageItem}>
            <img src={polytop} alt="Top 3 Students Result" className={styles.advantageImage} />
          </div>
          <div className={styles.advantageItem}>
            <img src={polystudent} alt="Student Video Participation" className={styles.advantageImage} />
          </div>
          <div className={styles.advantageItem}>
            <img src={polylearning} alt="Learning Through Competition." className={styles.advantageImage} />
          </div>
          <div className={styles.advantageItem}>
            <img src={polytrophy} alt="Trophies & Digital Certificates" className={styles.advantageImage} />
          </div>
        </div>
      </section>

      <section className={styles.schoolsSection}>
        <h2 className={styles.schoolsHeading}>
          <span className={styles.schoolsPart1}>PolyMatch for Schools – </span><br />
          <span className={styles.schoolsPart2}>Partner with Us</span>
        </h2>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <div className={styles.handImageContainer}>
          <img src={hand} alt="Handshake" className={styles.handImage} />
        </div>

        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <p className={styles.schoolsParagraph}>
          Join hands with PolyMatch and bring the best of 21st-century life skills to your students through our dynamic, curriculum-integrated programs. Our exclusive partnership will empower your school to equip students with the critical skills they need to excel in today's fast-paced world. Together, we can create an environment where creativity, collaboration, and critical thinking flourish.
        </p>

        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <h3 className={styles.partnershipSubHeading}>What You Get with Our Partnership</h3>

        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <div className={styles.partnershipGrid}>
          <div className={styles.partnershipItem}>
            <img src={polyex} alt="Poly Exhibition" className={styles.partnershipImage} />
          </div>
          <div className={styles.partnershipItem}>
            <img src={polystu} alt="Student Engagement" className={styles.partnershipImage} />
          </div>
          <div className={styles.partnershipItem}>
            <img src={polyearly} alt="Yearly Curriculum" className={styles.partnershipImage} />
          </div>
        </div>

        <h3 className={styles.readyHeading}>Ready to Get Started?</h3>
        <p className={styles.readyParagraph}>
          Contact us today to learn more about how PolyMatch can enhance your school's curriculum and empower your students. Register your interest now and take the first step toward creating a future-ready generation.
        </p>

        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <Link to="/PolymatchReg" className={styles.registerBtn}>Register Now</Link>
      </section>

      <CertificateVerification />

      <section className={styles.sponsorsSection}>
        <h2 className={styles.sponsorsHeading}>
          <span className={styles.sponsorsPart1}>Our Sponsors & </span><br />
          <span className={styles.sponsorsPart2}>Strategic Partners</span>
        </h2>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>
        <div className={styles.emptySpace}></div>

        <div className={styles.sponsorsGrid}>
          <div className={styles.sponsorItem}>
            <img src={ss1} alt="Sponsor 1" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss2} alt="Sponsor 2" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss3} alt="Sponsor 3" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss4} alt="Sponsor 4" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss5} alt="Sponsor 5" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss6} alt="Sponsor 6" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss7} alt="Sponsor 7" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss8} alt="Sponsor 8" className={styles.sponsorImage} />
          </div>
          <div className={styles.sponsorItem}>
            <img src={ss9} alt="Sponsor 9" className={styles.sponsorImage} />
          </div>
        </div>
      </section>

      <Testimonials />
      <FAQ />
      <section className={styles.gallerySection}>
        <div className={styles.container}>
          <div className={styles.galleryHeader}>
            <h2 className={styles.galleryTitle}>
              <span className={styles.galleryOf}>Gallery of </span>
              <span className={styles.learningGrowth}>Learning & Growth</span>
            </h2>
            <div className={styles.sunIcon}>
              <img src={require("../../assets/sun.png")} alt="Sun" />
            </div>
          </div>
          <div className={styles.galleryGrid}>
            {[...Array(8)].map((_, i) => (
              <div className={styles.galleryItem} key={i}>
                <img
                  src={require(`../../assets/kid${i + 7}.png`) || "/placeholder.svg"}
                  alt="Learning child"
                />
              </div>
            ))}
          </div>
          <div className={styles.calculatorIcon}>
            <img src={require("../../assets/calculator.png")} alt="Calculator" />
          </div>
          <div className={styles.galleryButton}>
            <Link to="/gallery">
              <img
                src={require("../../assets/viewgallery.png")}
                alt="View Gallery"
              />
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Polymatch;